import { shouldPolyfill } from '@formatjs/intl-numberformat/should-polyfill';

export async function polyfill(locale: string) {
  // We need this polyfill as well for ios 3-13
  await import('@formatjs/intl-locale/polyfill');
  await import('@formatjs/intl-pluralrules/polyfill');
  // Load the polyfill 1st BEFORE loading data
  await import('@formatjs/intl-numberformat/polyfill');

  try {
    if (locale) {
      if (!shouldPolyfill(locale)) {
        return;
      }
      // TODO in case we have many locales
      // see https://formatjs.io/docs/polyfills/intl-numberformat/#dynamic-import--capability-detection
      // and use similar approach to import and use diff locales
      await import(`@formatjs/intl-numberformat/locale-data/de`);
    }
  } catch (error) {
    const errorMsg = (error as Error)?.message;
    if (errorMsg?.includes('Incorrect locale information provided')) {
      console.error(`local ${locale} not found`);
      return;
    }
    console.error(error);
  }
}
